// The mailbox app's pages, ONE list: the router, the navigation, the bottom tab bar and the
// "?open=" translation of old links all read it, so a page cannot exist in one and not the others.
export interface MailboxPage {
  key: string;
  /** Path under the app's base, "" for the start page. */
  path: string;
  label: string;
}

export const MAILBOX_PAGES: MailboxPage[] = [
  { key: "mail", path: "mail", label: "Mail" },
  { key: "overview", path: "", label: "Overview" },
  { key: "spam", path: "spam", label: "Spam & held" },
  { key: "rules", path: "rules", label: "Rules" },
  { key: "import", path: "import", label: "Import & sync" },
  { key: "notifications", path: "notifications", label: "Notifications" },
  { key: "profile", path: "profile", label: "Profile" },
  { key: "security", path: "security", label: "Security" },
  { key: "settings", path: "settings", label: "Settings" },
];

/** On a phone running the installed app, these four sit in the bottom bar; More holds the rest. */
export const BOTTOM_TABS = ["mail", "overview", "spam", "rules"];
